import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../apiService';
import classes from './Login.module.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Clear notification on input change
    setNotification(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setNotification(null);

    // Form validation
    if (!formData.email || !formData.newPassword || !formData.confirmPassword) {
      setNotification({
        message: 'Please fill in all fields',
        type: 'error'
      });
      return;
    }

    // Email validation
    if (!formData.email.includes('@')) {
      setNotification({
        message: 'Please enter a valid email address',
        type: 'error'
      });
      return;
    }

    // New password validation
    if (formData.newPassword.length < 6) {
      setNotification({
        message: 'Password must be at least 6 characters',
        type: 'error'
      });
      return;
    }

    // Confirm password validation
    if (formData.newPassword !== formData.confirmPassword) {
      setNotification({
        message: 'Passwords do not match',
        type: 'error'
      });
      return;
    }

    setLoading(true);

    try {
      // Call forgot password API
      const response = await forgotPassword(
        formData.email,
        formData.newPassword
      );

      // Show success notification
      setNotification({
        message: response.message || 'Password reset successfully!',
        type: 'success'
      });

      // Redirect to login after 2 seconds
      setTimeout(() => {
        navigate('/');
      }, 2000);

    } catch (error) {
      // Show error notification
      setNotification({
        message: error.message || 'Password reset failed. Please try again.',
        type: 'error'
      });
      console.error('Forgot password error:', error);
    } finally {
      setLoading(false);
    }
  };

  // Notification styles (same as login)
  const notificationStyle = {
    marginTop: '20px',
    padding: '16px',
    borderRadius: '8px',
    border: notification?.type === 'success' ? '1px solid #86efac' : '1px solid #fca5a5',
    backgroundColor: notification?.type === 'success' ? '#dcfce7' : '#fee2e2',
    color: notification?.type === 'success' ? '#166534' : '#991b1b',
    animation: 'slideDown 0.3s ease-out',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  const closeButtonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    fontWeight: 'bold',
    cursor: 'pointer',
    opacity: 0.7,
    marginLeft: '15px',
    color: 'inherit',
  };

  return (
    <div className={classes.forgotPasswordContainer}>
      {/* Inline style for animation */}
      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      {/* Left Section - Image Background with Text Overlay */}
      <div className={classes.forgotPasswordLeftSection}>
        <img
          src="/Loginbg.png"
          alt="Forgot Password Background"
          className={classes.forgotPasswordImage}
        />
        <div className={classes.forgotPasswordLeftText}>
          DIGITAL<br />
          PRODUCT<br />
          PASSPORT
        </div>
      </div>

      {/* Right Section - White Background with Forgot Password Form */}
      <div className={classes.forgotPasswordRightSection}>
        <div className={classes.formWrapper}>
          {/* Forgot Password Form */}
          <div className={classes.formContainer}>
            <form className={classes.form} onSubmit={handleSubmit}>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className={classes.input}
                disabled={loading}
              />

              <input
                type="password"
                name="newPassword"
                placeholder="New Password"
                value={formData.newPassword}
                onChange={handleChange}
                className={classes.input}
                disabled={loading}
              />

              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm New Password"
                value={formData.confirmPassword}
                onChange={handleChange}
                className={classes.input}
                disabled={loading}
              />

              <button
                type="submit"
                className={classes.loginBtn}
                disabled={loading}
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>

            {/* Notification - appears below the form (inline like login) */}
            {notification && (
              <div style={notificationStyle}>
                <span style={{ fontWeight: 500 }}>{notification.message}</span>
                <button
                  onClick={() => setNotification(null)}
                  style={closeButtonStyle}
                  onMouseEnter={(e) => e.target.style.opacity = '1'}
                  onMouseLeave={(e) => e.target.style.opacity = '0.7'}
                >
                  ×
                </button>
              </div>
            )}
          </div>

          <div className={classes.forgotRow}>
            Remember your password?{' '}
            <span className={classes.forgotLink} onClick={() => navigate('/')}>
              Log In Here
            </span>
          </div>

          <div className={classes.signupBackBtn} onClick={() => navigate(-1)}>
            <span className={classes.backArrow}>&larr;</span> Back
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;